import { type Map as MaplibreMap } from "maplibre-gl";

import { COLOR_LABEL } from "@/constants/colors";
import { DatasetStyle } from "@/types/dataset";
import { FeatureDataConfig } from "@/types/map";

import { getLabelOffset, getTextSizeExpression } from "../map";

export const addLabelLayer = (
  isNewUIDatasetConfigEnabled: boolean,
  map: MaplibreMap | null,
  dataConfig: Omit<FeatureDataConfig, "data"> & { id: string },
  style: DatasetStyle,
  beforeId?: string
) => {
  if (!map || !dataConfig.sublayers || !isNewUIDatasetConfigEnabled) return;

  const visibility =
    style.visibility === "visible" && style.labelConfig?.show_label
      ? "visible"
      : "none";

  const isPOI = dataConfig.type === "poi";
  const isSiteProfiling = dataConfig.type === "site_profiling";

  const sourceId = map.getSource(`${dataConfig.id}-centroid`)
    ? `${dataConfig.id}-centroid`
    : dataConfig.id;

  map.addLayer(
    {
      id: dataConfig.sublayers.label,
      type: "symbol",
      source: sourceId,
      filter: ["!", ["has", "point_count"]],
      layout: {
        "symbol-placement": "point",
        "text-field": ["to-string", ["get", style.labelConfig?.attribute_name]],
        "text-font": ["Open Sans Bold", "Arial Unicode MS Regular"],
        "text-size": getTextSizeExpression(isPOI),
        "text-anchor": isPOI ? "bottom" : "center",
        "text-offset": [0, getLabelOffset(isPOI, isSiteProfiling)],
        "text-allow-overlap": false,
        "text-pitch-alignment": "viewport",
        "text-rotation-alignment": "viewport",
        visibility
      },
      paint: {
        "text-color":
          COLOR_LABEL[style.labelConfig?.color_scale || "BLACK_WHITE"].COLOR,
        "text-halo-color":
          COLOR_LABEL[style.labelConfig?.color_scale || "BLACK_WHITE"]
            .HALO_COLOR,
        "text-halo-width": 1.2,
        "text-opacity": 1
      }
    },
    beforeId
  );
};
